import addHours from "date-fns/addHours"
import format from "date-fns/format"
import { Dialog } from "primereact/dialog"
import { ProgressSpinner } from "primereact/progressspinner"
import React, { useEffect, useState } from "react"
import { Api } from "../../../../services/api"
import { formatCurrency, formatDocument } from "../../../../utils/formatCurrency"


function DetalhesDialog({cobranca_id, close}) {
    const [detalhesCobranca,setDetalhesCobranca] = useState([])
    const [loading,setLoading] = useState(true)

    useEffect(() => {
        async function carregaDetalhes(){
            setLoading(true)
            try {
                const {data} = await Api.get(`cobranca/detalhe_cobranca/${cobranca_id}`)
                setDetalhesCobranca(data)
            } catch (error) {
                console.log(error.response)
            } finally{
                setLoading(false)
            }
        }
        carregaDetalhes()
            
    }, [])

    return (

        <>
            <Dialog
                visible
                className='w-full lg:w-1/2'
                header="Detalhes da Cobrança"
                onHide={() => close()}
            >
                {!loading ?
                    <div className="font-lato-bold">
                    {/* {infoCobrancaDetalhe && console.log("BBBBBBBBBBBBBBBBBBBB", infoCobrancaDetalhe)} */}
                        <div className="flex justify-between p-4">
                            <div className="text-left">
                                <h6 className="text-green-600 font-bold text-lg">NOME CLIENTE</h6>
                                <h5 className="text-xl mb-1">{detalhesCobranca.usuario_nome}</h5>
                                <h6 className="text-green-600 font-bold text-lg">DOCUMENTO CLIENTE</h6>
                                <h5 className="text-xl mb-1">{formatDocument(detalhesCobranca.usuario_documento)}</h5>
                                <h6 className="text-green-600 font-bold text-lg">CÓDIGO CLIENTE</h6>
                                <h5 className="text-xl mb-1">{detalhesCobranca.cobranca_numero_cliente_credor}</h5>
                                <h6 className="text-green-600 font-bold text-lg">DESCRIÇÃO</h6>
                                <h5 className="text-xl mb-1">{detalhesCobranca.cobranca_descricao}</h5>
                                <h6 className="text-green-600 font-bold text-lg">DATA CRIAÇÃO</h6>
                                <h5 className="text-xl mb-1">{format(new Date(detalhesCobranca.cobranca_create),'dd/MM/yyyy HH:mm:ss')}</h5>
                            </div>
                            <div className="text-right">
                                <h6 className="text-green-600 font-bold text-lg">VALOR ORIGINAL</h6>
                                <h5 className="text-xl mb-1">{formatCurrency(detalhesCobranca.cobranca_valor)}</h5>
                                <h6 className="text-green-600 font-bold text-lg">JUROS</h6>
                                <h5 className="text-xl mb-1">{detalhesCobranca.juros} %</h5>
                                <h6 className="text-green-600 font-bold text-lg">MULTA</h6>
                                <h5 className="text-xl mb-1">{detalhesCobranca.multa} %</h5>
                                <h6 className="text-green-600 font-bold text-lg">NUMERO MÁX DE PARCELAS</h6>
                                <h5 className="text-xl mb-1">{detalhesCobranca.cobranca_boleto_parcela}</h5>
                                <h6 className="text-green-600 font-bold text-lg">VENCIMENTO</h6>
                                <h5 className="text-xl mb-1">{format(addHours(new Date(detalhesCobranca.data_vencimento_primeiro_boleto),3),'dd/MM/yyyy')}</h5>
                            </div>
                        </div>
                    </div> : 
                    <div className="justify-content-center flex ">
                        <ProgressSpinner strokeWidth="6" />
                    </div>
                }
            </Dialog>
        </>
    )

}

export default DetalhesDialog